<template>
  <div>
    <audio controls>
      <source :src="data.src" type="audio/mpeg" />
    </audio>
    <div v-if="data.caption" class="caption">{{ data.caption }}</div>
  </div>
</template>

<script>

  export default {
    name: 'ContentModuleAudio',
    props: {
      data: {
        type: Object,
        required: true
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  @import "~globals";

  audio {
    display:block; width:100%;
  }

  .caption {
    @include caption;
    margin-top:3rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/_global/content-module/audio.vue